"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ViewColumnsService", {
    enumerable: true,
    get: function() {
        return ViewColumnsService;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _GridViewColumn = /*#__PURE__*/ _interop_require_default(require("../models/GridViewColumn"));
const _GalleryViewColumn = /*#__PURE__*/ _interop_require_default(require("../models/GalleryViewColumn"));
const _KanbanViewColumn = /*#__PURE__*/ _interop_require_default(require("../models/KanbanViewColumn"));
const _MapViewColumn = /*#__PURE__*/ _interop_require_default(require("../models/MapViewColumn"));
const _FormViewColumn = /*#__PURE__*/ _interop_require_default(require("../models/FormViewColumn"));
const _apphooksservice = require("~/services/app-hooks/app-hooks.service");
const _helpers = require("~/helpers");
const _models = require("~/models");
const _catchError = require("~/helpers/catchError");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _NocoSocket = /*#__PURE__*/ _interop_require_default(require("~/socket/NocoSocket"));
const _viewwebhookmanager = require("~/utils/view-webhook-manager");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let ViewColumnsService = class ViewColumnsService {
    async columnList(context, param, ncMeta) {
        return await _models.View.getColumns(context, param.viewId, ncMeta);
    }
    async columnAdd(context, param, ncMeta) {
        (0, _helpers.validatePayload)('swagger.json#/components/schemas/ViewColumnReq', param.column);
        let viewWebhookManager;
        if (!param.viewWebhookManager) {
            var _param_viewWebhookManager;
            const view = await _models.View.get(context, param.viewId, ncMeta);
            viewWebhookManager = (_param_viewWebhookManager = param.viewWebhookManager) != null ? _param_viewWebhookManager : (await (await new _viewwebhookmanager.ViewWebhookManagerBuilder(context, ncMeta).withModelId(view.fk_model_id)).withViewId(view.id)).forUpdate();
        }
        const viewColumn = await _models.View.insertOrUpdateColumn(context, param.viewId, param.column.fk_column_id, {
            order: param.column.order,
            show: param.column.show
        });
        // this.appHooksService.emit(AppEvents.VIEW_COLUMN_CREATE, {
        //   viewColumn,
        //   req: param.req,
        //   context,
        // });
        if (viewWebhookManager) {
            (await viewWebhookManager.withNewViewId(viewWebhookManager.getViewId())).emit();
        }
        return viewColumn;
    }
    async columnUpdate(context, param, ncMeta) {
        if (context.schema_locked) {
            _catchError.NcError.get(context).schemaLocked();
        }
        (0, _helpers.validatePayload)('swagger.json#/components/schemas/ViewColumnUpdateReq', param.column);
        const view = await _models.View.get(context, param.viewId, ncMeta);
        if (!view) {
            _catchError.NcError.get(context).viewNotFound(param.viewId);
        }
        const oldViewColumn = await _models.View.getColumn(context, param.viewId, param.columnId, ncMeta);
        if (!oldViewColumn) {
            _catchError.NcError.get(context).fieldNotFound(param.columnId);
        }
        const column = await _models.Column.get(context, {
            colId: oldViewColumn.fk_column_id
        }, ncMeta);
        let viewWebhookManager;
        if (!param.viewWebhookManager) {
            var _param_viewWebhookManager;
            viewWebhookManager = (_param_viewWebhookManager = param.viewWebhookManager) != null ? _param_viewWebhookManager : (await (await new _viewwebhookmanager.ViewWebhookManagerBuilder(context, ncMeta).withModelId(view.fk_model_id)).withViewId(view.id)).forUpdate();
        }
        const result = await _models.View.updateColumn(context, param.viewId, param.columnId, param.column, ncMeta);
        const viewColumn = await _models.View.getColumn(context, param.viewId, param.columnId, ncMeta);
        this.appHooksService.emit(_nocodbsdk.AppEvents.VIEW_COLUMN_UPDATE, {
            viewColumn,
            oldViewColumn,
            view,
            column,
            internal: param.internal,
            req: param.req,
            context
        });
        _NocoSocket.default.broadcastEvent(context, {
            event: _nocodbsdk.EventType.META_EVENT,
            payload: {
                action: 'view_column_update',
                payload: _extends({}, oldViewColumn, viewColumn)
            }
        }, context.socket_id);
        if (viewWebhookManager) {
            (await viewWebhookManager.withNewViewId(viewWebhookManager.getViewId())).emit();
        }
        return result;
    }
    async columnsUpdate(context, param) {
        var _param_columns;
        const { viewId } = param;
        const columns = Array.isArray(param.columns) ? param.columns : (_param_columns = param.columns) == null ? void 0 : _param_columns[_nocodbsdk.APIContext.VIEW_COLUMNS];
        if (!columns) {
            _catchError.NcError.get(context).badRequest('Invalid request - fields not found');
        }
        const view = await _models.View.get(context, viewId);
        const updateOrInsertOptions = [];
        let result;
        const ncMeta = await _Noco.default.ncMeta.startTransaction();
        if (!view) {
            _catchError.NcError.get(context).viewNotFound('View not found');
        }
        let viewWebhookManager;
        if (!param.viewWebhookManager) {
            var _param_viewWebhookManager;
            viewWebhookManager = (_param_viewWebhookManager = param.viewWebhookManager) != null ? _param_viewWebhookManager : (await (await new _viewwebhookmanager.ViewWebhookManagerBuilder(context, ncMeta).withModelId(view.fk_model_id)).withViewId(view.id)).forUpdate();
        }
        try {
            const table = _models.View.extractViewColumnsTableName(view);
            // iterate over view columns and update/insert accordingly
            for (const [indexOrId, column] of Object.entries(columns)){
                const columnId = Array.isArray(param.columns) ? column['id'] : indexOrId;
                const existingCol = await ncMeta.metaGet2(context.workspace_id, context.base_id, table, {
                    fk_view_id: viewId,
                    fk_column_id: columnId
                });
                switch(view.type){
                    case _nocodbsdk.ViewTypes.GRID:
                        (0, _helpers.validatePayload)('swagger.json#/components/schemas/GridColumnReq', column);
                        if (existingCol) {
                            updateOrInsertOptions.push(_GridViewColumn.default.update(context, existingCol.id, column, ncMeta));
                        } else {
                            updateOrInsertOptions.push(_GridViewColumn.default.insert(context, _extends({}, column, {
                                fk_view_id: viewId,
                                fk_column_id: columnId
                            }), ncMeta));
                        }
                        break;
                    case _nocodbsdk.ViewTypes.GALLERY:
                        (0, _helpers.validatePayload)('swagger.json#/components/schemas/GalleryColumnReq', column);
                        if (existingCol) {
                            updateOrInsertOptions.push(_GalleryViewColumn.default.update(context, existingCol.id, column, ncMeta));
                        } else {
                            updateOrInsertOptions.push(_GalleryViewColumn.default.insert(context, _extends({}, column, {
                                fk_view_id: viewId,
                                fk_column_id: columnId
                            }), ncMeta));
                        }
                        break;
                    case _nocodbsdk.ViewTypes.KANBAN:
                        (0, _helpers.validatePayload)('swagger.json#/components/schemas/KanbanColumnReq', column);
                        if (existingCol) {
                            updateOrInsertOptions.push(_KanbanViewColumn.default.update(context, existingCol.id, column, ncMeta));
                        } else {
                            updateOrInsertOptions.push(_KanbanViewColumn.default.insert(context, _extends({}, column, {
                                fk_view_id: viewId,
                                fk_column_id: columnId
                            }), ncMeta));
                        }
                        break;
                    case _nocodbsdk.ViewTypes.MAP:
                        (0, _helpers.validatePayload)('swagger.json#/components/schemas/MapColumn', column);
                        if (existingCol) {
                            updateOrInsertOptions.push(_MapViewColumn.default.update(context, existingCol.id, column, ncMeta));
                        } else {
                            updateOrInsertOptions.push(_MapViewColumn.default.insert(context, _extends({}, column, {
                                fk_view_id: viewId,
                                fk_column_id: columnId
                            }), ncMeta));
                        }
                        break;
                    case _nocodbsdk.ViewTypes.FORM:
                        (0, _helpers.validatePayload)('swagger.json#/components/schemas/FormColumnReq', column);
                        if (existingCol) {
                            updateOrInsertOptions.push(_FormViewColumn.default.update(context, existingCol.id, column, ncMeta));
                        } else {
                            updateOrInsertOptions.push(_FormViewColumn.default.insert(context, _extends({}, column, {
                                fk_view_id: viewId,
                                fk_column_id: columnId
                            }), ncMeta));
                        }
                        break;
                    case _nocodbsdk.ViewTypes.CALENDAR:
                        (0, _helpers.validatePayload)('swagger.json#/components/schemas/CalendarColumnReq', column);
                        if (existingCol) {
                            updateOrInsertOptions.push(_models.CalendarViewColumn.update(context, existingCol.id, column, ncMeta));
                        } else {
                            updateOrInsertOptions.push(_models.CalendarViewColumn.insert(context, _extends({}, column, {
                                fk_view_id: viewId,
                                fk_column_id: columnId
                            }), ncMeta));
                        }
                        break;
                }
            }
            await Promise.all(updateOrInsertOptions);
            await ncMeta.commit();
            await _models.View.clearSingleQueryCache(context, view.fk_model_id, [
                view
            ]);
            if (viewWebhookManager) {
                (await viewWebhookManager.withNewViewId(viewWebhookManager.getViewId())).emit();
            }
            return result;
        } catch (e) {
            await ncMeta.rollback();
            if (e instanceof _catchError.NcError || e instanceof _nocodbsdk.NcBaseError) throw e;
            this.logger.error('Error updating view columns', e);
            _catchError.NcError.get(context).badRequest('Bad Request');
        }
    }
    async viewColumnList(context, param) {
        const columnList = await _models.View.getColumns(context, param.viewId, undefined);
        // generate key-value pair of column id and column
        const columnMap = columnList.reduce((acc, column)=>{
            acc[column.fk_column_id] = column;
            return acc;
        }, {});
        return columnMap;
    }
    constructor(appHooksService){
        this.appHooksService = appHooksService;
        this.logger = new _common.Logger(ViewColumnsService.name);
    }
};
ViewColumnsService = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _apphooksservice.AppHooksService === "undefined" ? Object : _apphooksservice.AppHooksService
    ])
], ViewColumnsService);
